const Services = () => {
  return <div></div>;
};

export default Services;
